import React, { useMemo } from "react";
import { Box, Icon } from "@bookingcom/bui-react";
import { CheckmarkSelectedFillIcon, CloseCircleFillIcon, DollarCircleFillIcon, WarningFillIcon } from "@bookingcom/bui-assets-react/streamline";
import style from "./IconWithInclusionType.module.css";
export function IconWithInclusionType(props) {
    const { svg, inclusionType, attributes, size } = props;
    const inclusionIconSvg = useMemo(() => {
        switch (inclusionType) {
            case "INCLUDED":
                return CheckmarkSelectedFillIcon;
            case "PARTIAL":
                return WarningFillIcon;
            case "NOT_AVAILABLE":
                return CloseCircleFillIcon;
            case "EXTRA":
            default:
                return DollarCircleFillIcon;
        }
    }, [inclusionType]);
    const inclusionIconColor = useMemo(() => {
        switch (inclusionType) {
            case "INCLUDED":
                return "constructive";
            case "NOT_AVAILABLE":
                return "destructive";
            default:
                return "neutral";
        }
    }, [inclusionType]);
    return (React.createElement(Box, { padding: 0, mixin: { paddingInlineEnd: 1 }, attributes: {
            ...attributes,
            style: {
                ...attributes?.style,
                display: "inline-block",
                position: "relative"
            }
        } },
        React.createElement(Icon, { size: size ?? "large", svg: svg }),
        React.createElement(Icon, { size: "smallest", svg: inclusionIconSvg, color: inclusionIconColor, className: style.iconBgFix, attributes: {
                style: {
                    position: "absolute",
                    insetBlockEnd: 0,
                    insetInlineEnd: 0,
                    visibility: inclusionType === "__HIDDEN" ? "hidden" : undefined,
                    opacity: inclusionType === "__HIDDEN" ? 0 : undefined
                }
            } })));
}
